import renderAutoSuggestWithOptions from 'app/employer/components/autoSuggest/AutoSuggestHOC';
import { companyTitleFromAudiencePivotAutoCompleteInput$, companyTitleFromAudiencePivotAutoCompleteObservable$ } from 'app/employer/redux/autosuggest/autoCompleteService';

const CompanyTitleFromAudiencePivotAutoSuggest = renderAutoSuggestWithOptions(
   companyTitleFromAudiencePivotAutoCompleteObservable$,
   companyTitleFromAudiencePivotAutoCompleteInput$,
);

CompanyTitleFromAudiencePivotAutoSuggest.defaultProps = {
   selected: {
      id: null,
      name: '',
   },
   filterOrganization: {
      id: null,
      name: '',
   },
   forceSelection: false,
   placeholder: 'Search Company Title...',
};

export default CompanyTitleFromAudiencePivotAutoSuggest;
